<template>
  <b-tooltip
    ref="tooltipRef"
    trigger="click"
    effect="light"
    v-bind="$attrs"
    :popper-class="`${ns.namespace.value}-popover`"
    :popper-style="style"
    :teleported="teleported"
    :fallback-placements="['bottom', 'top', 'right', 'left']"
    :hide-after="hideAfter"
    :persistent="persistent"
  >
    <template #content>
      <div
        :class="ns.b()"
        data-test-name="popconfirm"
        data-test-variant=""
        data-test-state=""
      >
        <div :class="ns.e('main')">
          <b-icon
            v-if="!hideIcon && icon"
            :class="ns.e('icon')"
            :size="24"
            :style="{ color: iconColor }"
          >
            <component :is="icon" />
          </b-icon>
          <div :class="ns.e('content')">
            <slot>{{ title }}</slot>
          </div>
        </div>
        <div :class="ns.e('action')">
          <b-button small :ghost="cancelButtonType === 'ghost'" @click="cancel">
            {{ finalCancelButtonText }}
          </b-button>
          <b-button small primary @click="confirm">
            {{ finalConfirmButtonText }}
          </b-button>
        </div>
      </div>
    </template>
    <template v-if="$slots.reference">
      <slot name="reference" />
    </template>
  </b-tooltip>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import BButton from '@bigin/components/button'
import BIcon from '@bigin/components/icon'
import BTooltip from '@bigin/components/tooltip'
import { useLocale, useNamespace } from '@bigin/hooks'
import { addUnit } from '@bigin/utils'
import { popconfirmProps } from './popconfirm'

import type { TooltipInstance } from '@bigin/components/tooltip'

defineOptions({
  name: 'BPopconfirm',
})

const props = defineProps(popconfirmProps)

const { t } = useLocale()
const ns = useNamespace('popconfirm')
const tooltipRef = ref<TooltipInstance>()

const hidePopper = () => {
  tooltipRef.value?.onClose?.()
}

const style = computed(() => {
  return {
    width: addUnit(props.width),
  }
})

const confirm = (e: Event) => {
  props.onConfirm?.(e)
  hidePopper()
}
const cancel = (e: Event) => {
  props.onCancel?.(e)
  hidePopper()
}

const finalConfirmButtonText = computed(
  () => props.confirmButtonText || t('b.popconfirm.confirmButtonText')
)
const finalCancelButtonText = computed(
  () => props.cancelButtonText || t('b.popconfirm.cancelButtonText')
)
</script>
